/**
 * Pixel sizes aligned with entry redesign UI (theme .display-*, Ion components).
 * Update alongside `EntrySectionCard`, `SubSectionCard`, and form sections when those change.
 */

/** `EntrySectionCard` leading emoji square */
export const PARENT_CARD_LEADING_ICON_BOX_PX = 72;
export const PARENT_CARD_LEADING_ICON_RADIUS_PX = 18;

/** `.card-icon-size-1` trash on entry cards */
export const PARENT_CARD_TRASH_ICON_PX = 30;

/** `.display-3` + `.lh-110` (2.1875rem × 1.1) */
export const SKELETON_DISPLAY_3_LINE_PX = 39;

/** `.display-4` + `.lh-120` (1.2rem × 1.2) */
export const SKELETON_DISPLAY_4_LINE_PX = 23;

/** `.pt-1` gap between stacked subtitles */
export const SKELETON_TITLE_SUBTITLE_GAP_PX = 4;

/** `EntryCardChip` (`display-4.5`, `px-3`) */
export const PARENT_CARD_CHIP_HEIGHT_PX = 34;
export const PARENT_CARD_CHIP_WIDTH_EVENT_INFO_PX = 92;
export const PARENT_CARD_CHIP_WIDTH_NOT_STARTED_PX = 104;
/** Chip row `.pt-2.pb-2` */
export const PARENT_CARD_CHIP_ROW_VERTICAL_PADDING_PX = 16;

/** Collapsed `IonButton` `expand="block"` `display-4` */
export const PARENT_CARD_CTA_HEIGHT_PX = 48;

/** Entry Summary collapsed preview (`minHeight: 72px`, `padding: 8px 10px`) */
export const SUMMARY_COLLAPSED_PREVIEW_MIN_HEIGHT_PX = 72;
export const SUMMARY_COLLAPSED_PREVIEW_ICON_PX = 48;
export const SUMMARY_COLLAPSED_PREVIEW_ICON_RADIUS_PX = 10;

/** `SelectBarnFromAllBarns` / react-select control */
export const REACT_SELECT_CONTROL_HEIGHT_PX = 38;

/** Barn member card (radio + header + 3 lines + chip row) */
export const BARN_CARD_CONTENT_MIN_HEIGHT_PX = 152;

/** Stacked label + `IonInput` / reactstrap `Input` */
export const FORM_FIELD_LABEL_PX = 20;
export const FORM_FIELD_INPUT_PX = 44;
export const FORM_FIELD_LABEL_GAP_PX = 8;

/** `EventInfoSection` inner white card */
export const EVENT_INFO_SUBTITLE_LINE_PX = 16;
export const EVENT_INFO_TITLE_LINE_PX = 32;
export const EVENT_INFO_CONTACT_ROW_PX = 24;

/** `ClassInfoSection` inner cards */
export const CLASS_CARD_TITLE_PX = 24;
export const CLASS_CARD_SEARCH_PX = 40;
export const CLASS_CARD_BLOCK_PX = 72;

/** `SubSectionCard` collapsible header + stabling notes footer */
export const STABLING_NOTES_CARD_MIN_HEIGHT_PX = 128;
